export default __webpack_public_path__ + "static/media/077-france.cb2bd336.svg";